<template>
  <div>
    <Loading :loading="this.loading"></Loading>
    <div v-show="!loading" v-if="input">
      <button v-on:click="estimatePage()" id="isInput" class="button fs16 mb20 pd16 w80p" style="display: none;"></button>
      <PreferredDateInput
        v-bind:pitlock="pitlock"
        v-bind:inspection="inspection"
        v-bind:ssInfo="ssInfo"
        v-bind:pitlockCalendar="pitlockCalendar"
        v-bind:pitlockSlots="pitlockSlots"
        @toConfirmCheck="toConfirmCheck"
        @nextCalendar="nextCalendar"
        @previousCalendar="previousCalendar"
        @dayClick="dayClick"
        @timeClick="timeClick"
        @dontSelectSchedule="dontSelectSchedule"
      >
      </PreferredDateInput>
    </div>
    <div v-if="confirm">
      <a id="isConfirm"></a>
      <PreferredDateConfirm
        @backToInput="backToInput"
        @toCompleteCheck="toCompleteCheck"
        v-bind:pitlock="pitlock"
        v-bind:inspection="inspection"
        v-bind:car="this.preferredDateStore.preferredDate.car"
        v-bind:price="this.preferredDateStore.preferredDate.price"
        v-bind:expiryOnWareki="this.preferredDateStore.preferredDate.expiryOnWareki"
        v-bind:firstRegistrationOnWareki="this.preferredDateStore.preferredDate.firstRegistrationOnWareki"
        v-bind:Manufacturer="this.preferredDateStore.preferredDate.Manufacturer"
        v-bind:carType="this.preferredDateStore.preferredDate.carType"
        v-bind:processing="processing"
        v-bind:ssInfo="ssInfo"
        v-bind:pitlockCalendar="pitlockCalendar"
        v-bind:pitlockSlots="pitlockSlots"
      >
      </PreferredDateConfirm>
    </div>
    <div v-if="complete">
      <PreferredDateComplete
        v-bind:ssInfo="ssInfo"
        v-bind:nativeData="this.preferredDateStore.preferredDate.nativeData"
        v-bind:versionData="this.preferredDateStore.preferredDate.versionData"
        v-bind:pitlock="pitlock"
        v-bind:pitlockCalendar="pitlockCalendar"
        v-bind:pitlockSlots="pitlockSlots"
      ></PreferredDateComplete>
    </div>
  </div>
</template>
<script>

import inspectionApi from '@/store/Api/inspection'
import bookingCalendarCallingApi from '@/store/Api/Pitlock/bookingCalendarCalling'
import bookingSlotsCallingApi from '@/store/Api/Pitlock/bookingSlotsCalling'
import shopMenuListCallingApi from '@/store/Api/Pitlock/shopMenuListCalling'
import popinfoCouponUseApi from '@/store/Api/Popinfo/popinfoCouponUse'
import PreferredDateInput from '@/views/v2/PreferredDateInput.vue'
import PreferredDateConfirm from '@/views/v2/PreferredDateConfirm.vue'
import PreferredDateComplete from '@/views/v2/PreferredDateComplete.vue'
import Loading from '@/views/v2/Loading.vue'
import modal from '@/assets/v2/modal'
import emoji from 'emoji-regex'
import config from '@/v2/config'
import pitlockFunc from '@/v2/pitlockFunctions'
import moment from 'moment'
import { usePreferredDateStore } from '@/store/preferredDate'
import { useCarStore } from '@/store/carData'
import { useNativeDataStore } from '@/store/nativeData'
import { useTsIdStore } from '@/store/tsId'
import { useSsInfoStore } from '@/store/ssInfo'
import { useInspectSsInfoStore } from '@/store/inspectSsInfo'
import { useProfileInfoStore } from '@/store/profileInfo'
import { useVersionDataStore } from '@/store/versionData'

export default {
  data: () => ({
    pitlock: {
      last_name: '',
      first_name: '',
      start_decision: 0,
      start_at: null
    },
    inspection: {
      tel: '',
      user_request: '',
      replacement_vehicle_requested: 'false'
    },
    agreement: {
      matter1: false,
      matter2: false,
      matter3: false,
      matter4: false,
      matter5: false
    },
    post: {
      ts_id: '',
      tel: '',
      user_request: '',
      replacement_vehicle_requested: '',
      estimate_price: '',
      application_category: config.APPLICATION_CATEGORY_APP,
      estimate: {},
      price: {},
      pitlock: {}
    },
    // pitlockCalendarオブジェクトの説明については下記のISSUE参照
    // https://gitlab.ssl.iridge.jp/cosmo-oil/web-front/-/issues/86
    pitlockCalendar: {
      visible: [],
      box: [],
      number: 0,
      visibleYyyyMm: '',
      boxYyyyMm: [],
      day: {
        activeIndex: null,
        information: null
      },
      canUsePitlock: false,
      yyyyMm: null
    },
    // pitlockSlotsオブジェクトの説明については下記のISSUE参照
    // https://gitlab.ssl.iridge.jp/cosmo-oil/web-front/-/issues/86
    pitlockSlots: {
      loading: false,
      list: [],
      yyyyMmDd: '',
      time: {
        activeIndex: null,
        information: null
      },
      error: false
    },
    loading: true,
    input: true,
    confirm: false,
    complete: false,
    ssInfo: [],
    isSuccses: true,
    processing: false
  }),
  components: {
    PreferredDateInput,
    PreferredDateConfirm,
    PreferredDateComplete,
    Loading
  },
  computed: {
    preferredDateStore: function () {
      return usePreferredDateStore()
    }
  },
  methods: {
    // 入力 → 確認画面遷移バリデーション
    async toConfirmCheck (inspection, pitlock, form) {
      this.isSuccses = true
      // PITLOCKカレンダー情報取得関数
      this.pitlockScheduleFormSet()
      // トラッキング処理
      this.nativeEVENTSet('ShakenKiboubiButton', 'MOVED_YOYAKU_KAKUNIN', 'TAP')
      // 市外局番ありパターン
      /* eslint-disable-next-line prefer-regex-literals */
      const landLineRegex = new RegExp(/^0(\d{1}[-(]?\d{4}|\d{2}[-(]?\d{3}|\d{3}[-(]?\d{2}|\d{4}[-(]?\d{1})[-)]?\d{4}$/)
      // 携帯電話パターン
      /* eslint-disable-next-line prefer-regex-literals */
      const mobileRegex = new RegExp(/^0[5789]0[-(]?\d{4}[-)]?\d{4}$/)

      // PITLOCKの日時選択はされていて、予約可能時刻が選ばれていない場合はエラー
      if (this.pitlockCalendar.day.information && !this.pitlockSlots.time.information) {
        form.pitlockTimeErrorMessage = '時刻を選択して下さい'
        this.pitlockSlots.error = true
        this.isSuccses = false
      } else {
        form.pitlockTimeErrorMessage = ''
        this.pitlockSlots.error = false
      }

      // 姓が空白であればエラー
      if (!pitlock.last_name) {
        form.lastNameErrorMessage = '姓をご入力ください。'
        this.isSuccses = false
      } else if (pitlock.last_name.length >= 21) {
        // 姓が20文字以上であればエラー
        form.lastNameErrorMessage = '20字以内でご入力ください。'
        this.isSuccses = false
      } else {
        form.lastNameErrorMessage = ''
      }

      // 名が20文字以上であればエラー
      if (pitlock.first_name.length >= 21) {
        form.firstNameErrorMessage = '20字以内でご入力ください。'
        this.isSuccses = false
      } else {
        form.firstNameErrorMessage = ''
      }

      // 連絡先電話番号
      if (!landLineRegex.test(inspection.tel) && !mobileRegex.test(inspection.tel)) {
        form.telErrorMessage = '電話番号の形式に誤りがあります。'
        this.isSuccses = false
      } else {
        // 電話番号が正しい場合はハイフンを除去
        this.inspection.tel = this.inspection.tel.replace(/-/g, '')
        form.telErrorMessage = ''
      }

      // 備考(任意)
      const match = emoji().exec(inspection.user_request)
      // 備考(任意)が100文字以上であればエラー
      if (inspection.user_request.length >= 101) {
        form.userRequestErrorMessage = '備考(任意)は100文字以内で入力してください。'
        this.isSuccses = false
      } else if (match) {
        //  備考(任意)に絵文字が含まれていればエラー
        form.userRequestErrorMessage = '備考(任意)に絵文字は入力できません。'
        this.isSuccses = false
      } else {
        form.userRequestErrorMessage = ''
      }

      if (this.isSuccses) {
        this.pitlock = pitlock
        this.inspection = inspection
        this.input = false
        this.confirm = true
        window.scroll(0, 0)
      } else {
        let scrollId = ''
        if (form.pitlockTimeErrorMessage !== '') {
          scrollId = '#pitlockTime'
        } else if (form.lastNameErrorMessage !== '') {
          scrollId = '#lastName'
        } else if (form.firstNameErrorMessage !== '') {
          scrollId = '#firstName'
        } else if (form.telErrorMessage !== '') {
          scrollId = '#tel'
        } else if (form.userRequestErrorMessage !== '') {
          scrollId = '#userRequest'
        }
        this.$SmoothScroll(
          document.querySelector(scrollId),
          500,
          null,
          null,
          'y'
        )
      }
    },
    // 確認 → 完了画面遷移バリデーション
    async toCompleteCheck (agreement, form) {
      this.isSuccses = true
      // トラッキング処理
      this.nativeEVENTSet('ShakenKakuninButton', 'MOVED_SHAKEN_MOSIKOMI', 'TAP')
      if (agreement.matter1 && agreement.matter2) {
        // 二度押しを防ぐ為、ロック開始
        this.processing = true
        // POST送信するためにデータを整形する
        /* eslint-disable no-multi-spaces */
        this.post.ts_id                                     = this.preferredDateStore.preferredDate.car.ts_id
        this.post.tel                                       = this.inspection.tel
        this.post.user_request                              = this.inspection.user_request
        this.post.replacement_vehicle_requested             = (this.inspection.replacement_vehicle_requested === 'true')
        this.post.estimate_price                            = this.preferredDateStore.preferredDate.price.total
        this.post.ss_name                                   = this.ssInfo.ss_name
        this.post.mail_address_1                            = this.ssInfo.mail_address_1
        this.post.mail_address_2                            = this.ssInfo.mail_address_2
        this.post.mail_address_3                            = this.ssInfo.mail_address_3
        this.post.mail_address_4                            = this.ssInfo.mail_address_4
        this.post.mail_address_5                            = this.ssInfo.mail_address_5
        this.post.estimate.ts_id                            = this.preferredDateStore.preferredDate.car.ts_id
        this.post.estimate.popinfo_id                       = this.preferredDateStore.preferredDate.nativeData.popinfoid
        this.post.estimate.prefecture_name                  = this.ssInfo.prefecture
        this.post.estimate.coupon_id                        = this.preferredDateStore.preferredDate.car.coupon_id
        this.post.estimate.cars_id                          = this.preferredDateStore.preferredDate.car.id
        this.post.estimate.ss_code                          = this.ssInfo.ss_code
        this.post.estimate.ss_factory_type_code             = this.ssInfo.factory_type_flag
        this.post.estimate.mileage                          = this.preferredDateStore.preferredDate.car.mileage
        this.post.estimate.weight                           = this.preferredDateStore.preferredDate.car.weight
        this.post.estimate.model_code                       = this.preferredDateStore.preferredDate.car.model_code
        this.post.estimate.plate_number                     = this.preferredDateStore.preferredDate.car.plate_number
        this.post.estimate.first_registration_on            = this.preferredDateStore.preferredDate.car.first_registration_on
        this.post.estimate.manufacturer_id                  = this.preferredDateStore.preferredDate.car.manufacturer_id
        this.post.estimate.expiry_on                        = this.preferredDateStore.preferredDate.car.expiry_on
        this.post.estimate.oil_exchanged                    = this.preferredDateStore.preferredDate.car.oil_exchanged
        this.post.estimate.tax                              = this.taxRate()
        this.post.price.cali_fee                            = this.preferredDateStore.preferredDate.price.legal_fee.cali_fee
        this.post.price.weight_tax                          = this.preferredDateStore.preferredDate.price.legal_fee.weight_tax
        this.post.price.revenue_stamp_fee                   = this.preferredDateStore.preferredDate.price.legal_fee.revenue_stamp_fee
        this.post.price.base_price                          = this.preferredDateStore.preferredDate.price.price.base_price
        this.post.price.oil_exchanged_fee                   = this.preferredDateStore.preferredDate.price.price.oil_exchanged_fee
        this.post.price.coupon_fee                          = this.preferredDateStore.preferredDate.price.coupon_fee
        this.post.pitlock.store_id                          = this.preferredDateStore.preferredDate.inspectSsInfo.store_id
        this.post.pitlock.last_name                         = this.pitlock.last_name
        this.post.pitlock.first_name                        = this.pitlock.first_name
        this.post.pitlock.start_decision                    = this.pitlock.start_decision
        this.post.pitlock.start_at                          = this.pitlock.start_at
        this.post.pitlock.motor_model                       = this.preferredDateStore.preferredDate.car.motor_model
        this.post.pitlock.type_designation_number           = this.preferredDateStore.preferredDate.car.type_designation_number
        this.post.pitlock.classification_division_number    = this.preferredDateStore.preferredDate.car.classification_division_number
        this.post.pitlock.chassis_number                    = this.preferredDateStore.preferredDate.car.chassis_number
        this.post.pitlock.menu_type                         = this.getMenuType(this.preferredDateStore.preferredDate.car.model_code)
        /* eslint-enable no-multi-spaces */
        // クーポンが存在する場合、FANSHIPクーポン使用APIの呼び出し
        if (this.preferredDateStore.preferredDate.car.coupon.uuid) {
          console.log('*** popinfoUsePost-requestParam ***')
          console.log('popinfoId  : ' + this.preferredDateStore.preferredDate.nativeData.popinfoid)
          console.log('couponUuid : ' + this.preferredDateStore.preferredDate.car.coupon.uuid)
          this.popinfoUsePost(this.preferredDateStore.preferredDate.nativeData.popinfoid, this.preferredDateStore.preferredDate.car.coupon.uuid)
        }

        // POST送信
        console.log('*** inspectionApiPost-requestParam ***')
        console.log(this.post)
        this.inspectionApiPost(this.post)
        // 二度押しロック解除
        // this.processing = false
      } else {
        form.agreementErrorMessage = '確認・同意項目すべてにチェックを入れてください。'
      }
    },
    // 車検テーブルのPOST実行
    async inspectionApiPost (post) {
      await inspectionApi.post(post).then(res => {
        if (this.isSuccses) {
          window.scroll(0, 0)
          this.confirm = false
          this.complete = true
          // 二度押しロック解除
          this.processing = false
        }
      }).catch(e => {
        if (this.expectedErrorOrNot(e.response.data.pitlock_cls001.error_info)) {
          const preferredDateInputObj = {
            name: 'RedirectPreferredDateV2',
            params: {
              price: this.preferredDateStore.preferredDate.price,
              car: this.preferredDateStore.preferredDate.car,
              expiryOnWareki: this.preferredDateStore.preferredDate.expiryOnWareki,
              firstRegistrationOnWareki: this.preferredDateStore.preferredDate.firstRegistrationOnWareki,
              Manufacturer: this.preferredDateStore.preferredDate.Manufacturer,
              carType: this.preferredDateStore.preferredDate.carType,
              nativeData: this.preferredDateStore.preferredDate.nativeData,
              tsId: this.preferredDateStore.preferredDate.tsId,
              ssInfo: this.preferredDateStore.preferredDate.ssInfo,
              inspectSsInfo: this.preferredDateStore.preferredDate.inspectSsInfo,
              profileInfo: this.preferredDateStore.preferredDate.profileInfo,
              versionData: this.preferredDateStore.preferredDate.versionData,
              pitlockshopDetails: this.preferredDateStore.preferredDate.pitlockshopDetails,
              post
            }
          }
          this.openErrorModal(
            '恐れ入りますが、別の日程を再度ご指定の上、お申し込みをお願いいたします。',
            'ご希望の日程をお取りすることができませんでした。',
            '日程選択画面へ',
            preferredDateInputObj
          )
        } else {
          this.openErrorModal('エラーが発生しました。')
        }
        // 二度押しロック解除
        this.processing = false
      })
    },
    // 車検テーブルのPOST実行
    async popinfoUsePost (popinfoId, couponUuid, os) {
      await popinfoCouponUseApi.post(popinfoId, couponUuid, os).then(res => {
        if (res.data.status === 'OK') {
          console.log('popinfoCouponUseApi Succses')
        } else {
          console.log('popinfoCouponUseApi Error')
        }
        console.log('popinfoCouponUseApi responseData')
        console.log(res.data)
      }).catch(e => {
        this.openErrorModal('エラーが発生しました。')
      })
    },
    // 入力画面へ戻る
    async backToInput (inspection, pitlock) {
      window.scrollTo(0, 0)
      this.pitlock = pitlock
      this.inspection = inspection
      this.input = true
      this.confirm = false
      this.complete = false
    },
    setSsInfo (ssInfo) {
      this.ssInfo = ssInfo
    },
    openErrorModal (message, title = 'エラーが発生しました', buttonMessage = '閉じる', otherPageMoveObj = null) {
      modal.alert(message, title, buttonMessage, otherPageMoveObj)
    },
    /**
    * [S008] ネット予約受付日カレンダー情報返却API呼び出し関数(初回アクセス時)
    * @param {string} targetYyyyMm - 処理実行月(yyyy-mm)
    * @param {string} nextTargetYyyyMm - 処理実行月翌月(yyyy-mm)
    */
    async firstGetbookingCalendar (targetYyyyMm, nextTargetYyyyMm) {
      await bookingCalendarCallingApi.get(this.preferredDateStore.preferredDate.inspectSsInfo.store_id, this.getMenuType(this.preferredDateStore.preferredDate.car.model_code), targetYyyyMm, nextTargetYyyyMm).then(res => {
        const { shapedCalendar, shapedYyyyMm } = pitlockFunc.shapedCalendar(res.data.body.calendar)
        this.pitlockCalendar.box = shapedCalendar
        this.pitlockCalendar.boxYyyyMm = shapedYyyyMm
        this.pitlockCalendar.visible = this.pitlockCalendar.box[0]
        this.pitlockCalendar.visibleYyyyMm = this.pitlockCalendar.boxYyyyMm[0]
        this.pitlockCalendar.yyyyMm = targetYyyyMm
      }).catch(e => {
        this.openErrorModal('エラーが発生しました。')
      })
    },
    /**
    * [S008] ネット予約受付日カレンダー情報返却API呼び出し関数(初回アクセス以降)
    * @param {string} targetYyyyMm - 処理実行月(yyyy-mm)
    */
    async getbookingCalendar (targetYyyyMm) {
      await bookingCalendarCallingApi.get(this.preferredDateStore.preferredDate.inspectSsInfo.store_id, this.getMenuType(this.preferredDateStore.preferredDate.car.model_code), targetYyyyMm, targetYyyyMm).then(res => {
        const { shapedCalendar, shapedYyyyMm } = pitlockFunc.shapedCalendar(res.data.body.calendar)
        this.pitlockCalendar.box[this.pitlockCalendar.number] = shapedCalendar[0]
        this.pitlockCalendar.boxYyyyMm[this.pitlockCalendar.number] = shapedYyyyMm[0]
        this.pitlockCalendar.visible = this.pitlockCalendar.box[this.pitlockCalendar.number]
        this.pitlockCalendar.visibleYyyyMm = this.pitlockCalendar.boxYyyyMm[this.pitlockCalendar.number]
        this.pitlockCalendar.yyyyMm = targetYyyyMm
      }).catch(e => {
        this.openErrorModal('エラーが発生しました。')
      })
    },
    /**
    * [S001] web予約可能枠照会API呼び出し関数
    */
    async getBookingSlots () {
      await bookingSlotsCallingApi.get(this.preferredDateStore.preferredDate.inspectSsInfo.store_id, this.getMenuType(this.preferredDateStore.preferredDate.car.model_code), this.pitlockCalendar.day.information.dayYyyyMmdd, this.pitlockCalendar.day.information.dayYyyyMmdd).then(res => {
        const { shapedSlots, shapedYyyyMmDd } = pitlockFunc.shapedSlots(res.data.body.reserve_available_list, this.pitlockCalendar.day.information)
        this.pitlockSlots.list = shapedSlots
        this.pitlockSlots.yyyyMmDd = shapedYyyyMmDd
        this.pitlockSlots.loading = false
      }).catch(e => {
        this.openErrorModal('エラーが発生しました。')
      })
    },
    /**
    * [CLS003] 店舗のメニューリストAPI呼び出し関数
    */
    async getshopMenuList () {
      await shopMenuListCallingApi.get(this.preferredDateStore.preferredDate.inspectSsInfo.store_id).then(res => {
        const canUsePitlock = pitlockFunc.getCanUsePitlock(res.data.body.menu_details_list, this.getMenuType(this.preferredDateStore.preferredDate.car.model_code))
        this.pitlockCalendar.canUsePitlock = canUsePitlock
      }).catch(e => {
        this.openErrorModal('エラーが発生しました。')
      })
    },
    /**
    * カレンダー次月遷移関数（「＞」押下時）
    */
    async nextCalendar () {
      if (this.pitlockSlots.loading) return
      const targetCalendar = moment(this.pitlockCalendar.yyyyMm).add(1, 'months').format('YYYY-MM')
      if (this.canCalenderBackOrForward(targetCalendar)) {
        this.loading = true
        this.pitlockCalendar.number++
        await this.clickedDayInitialize()
        await this.slotsInitialize()
        await this.pitlockFormInitialize()
        if (this.pitlockCalendar.box[this.pitlockCalendar.number]) {
          this.$set(this.pitlockCalendar, 'visible', this.pitlockCalendar.box[this.pitlockCalendar.number])
          this.$set(this.pitlockCalendar, 'visibleYyyyMm', this.pitlockCalendar.boxYyyyMm[this.pitlockCalendar.number])
          this.pitlockCalendar.yyyyMm = targetCalendar
        } else {
          await this.getbookingCalendar(targetCalendar)
        }
        this.loading = false
      }
    },
    /**
    * カレンダー先月遷移関数（「＜」押下時）
    */
    async previousCalendar () {
      if (this.pitlockSlots.loading) return
      const targetCalendar = moment(this.pitlockCalendar.yyyyMm).add(-1, 'months').format('YYYY-MM')
      if (this.canCalenderBackOrForward(targetCalendar)) {
        this.loading = true
        this.pitlockCalendar.number--
        await this.clickedDayInitialize()
        await this.slotsInitialize()
        await this.pitlockFormInitialize()
        this.pitlockCalendar.yyyyMm = targetCalendar
        this.$set(this.pitlockCalendar, 'visible', this.pitlockCalendar.box[this.pitlockCalendar.number])
        this.$set(this.pitlockCalendar, 'visibleYyyyMm', this.pitlockCalendar.boxYyyyMm[this.pitlockCalendar.number])
        this.loading = false
      }
    },
    /**
    * カレンダー「日」押下時関数
    * @param {string} index - カレンダー日インデックス
    * @param {object} day - 押下日情報
    */
    async dayClick (index, day) {
      // 過去日、空白マス、S001API呼び出し中は処理を行わない。
      if (this.pastDayOrNot(day.dayYyyyMmdd)) return
      if (!day.display) return
      if (this.pitlockSlots.loading) return
      const dayIndex = `${day.weekNumber}-${index}`
      if (this.pitlockCalendar.day.activeIndex === dayIndex) {
        this.pitlockCalendar.day.activeIndex = null
        this.pitlockCalendar.day.information = null
        this.slotsInitialize()
      } else {
        this.pitlockCalendar.day.activeIndex = dayIndex
        this.pitlockCalendar.day.information = day
        this.slotsInitialize()
        this.pitlockSlots.loading = true
        await this.getBookingSlots()
      }
    },
    /**
    * 「時間」 押下時関数
    * @param {string} index - 予約可能紹介枠インデックス
    * @param {object} time - 押下時刻情報
    */
    async timeClick (index, time) {
      if (time.available_type !== 1) return
      const timeIndex = `${time.row_number}-${index}`
      if (this.pitlockSlots.time.activeIndex === timeIndex) {
        this.pitlockSlots.time.activeIndex = null
        this.pitlockSlots.time.information = null
      } else {
        this.pitlockSlots.time.activeIndex = timeIndex
        this.pitlockSlots.time.information = time
      }
    },
    /**
    * 押下日初期化関数
    */
    async clickedDayInitialize () {
      this.pitlockCalendar.day.activeIndex = null
      this.pitlockCalendar.day.information = null
    },
    /**
    * 押下時間初期化関数
    */
    async slotsInitialize () {
      this.pitlockSlots.time.activeIndex = null
      this.pitlockSlots.time.information = null
      this.pitlockSlots.error = false
      this.$set(this.pitlockSlots, 'list', [])
      this.$set(this.pitlockSlots, 'yyyyMmDd', null)
    },
    /**
    * PITLOCKカレンダー情報（フォーム用）初期化関数
    */
    async pitlockFormInitialize () {
      this.pitlock.start_decision = config.START_DECISION_UNSURE
      this.pitlock.start_at = null
    },
    /**
    * 「日時を選択せずに進む」押下時関数
    */
    async dontSelectSchedule () {
      if (this.pitlockSlots.loading) return
      await this.clickedDayInitialize()
      await this.slotsInitialize()
      await this.pitlockFormInitialize()
      this.$SmoothScroll(document.querySelector('#customerPanel'), 500, null, null, 'y')
    },
    /**
    * カレンダー移動制御判別関数
    * 当月〜半年先までのみカレンダー表示させる為、その期間以上の遷移の際は
    * false判定（移動させない）仕様とする
    */
    canCalenderBackOrForward (yyyyMm) {
      const now = moment().format('YYYY-MM')
      const afterSixMonth = moment().add(6, 'months').format('YYYY-MM')
      if (now <= yyyyMm && yyyyMm < afterSixMonth) {
        return true
      }
      return false
    },
    /**
    * 過去日判定関数
    */
    pastDayOrNot (yyyyMmDd) {
      const today = moment().format('YYYY-MM-DD')
      if (yyyyMmDd < today) {
        return true
      }
      return false
    },
    /**
    * PITLOCKカレンダー情報（フォーム用）セッティング関数
    */
    pitlockScheduleFormSet () {
      if (this.pitlockCalendar.day.information && this.pitlockSlots.time.information) {
        const shapedDay = this.pitlockCalendar.day.information.dayYyyyMmdd.split('-')
        this.pitlock.start_decision = config.START_DECISION_SURE
        this.pitlock.start_at = `${shapedDay.join('/')} ${this.pitlockSlots.time.information.reception_hour}:00`
      }
    },
    /**
    * ユーザー操作 エラー判別関数
    * ref:https://gitlab.ssl.iridge.jp/cosmo-oil/web-front/-/issues/86#%E8%BF%BD%E8%A8%98-1019
    */
    expectedErrorOrNot (clsErrorInfos) {
      if (!clsErrorInfos) return false
      for (const clsErrorInfo of clsErrorInfos) {
        switch (clsErrorInfo.error_code) {
          case config.PITLOCK_ERROR_CODE_WORKING_DAY_OVER:
          case config.PITLOCK_ERROR_CODE_WORKING_START_TIME_OUT_OF_RANGE:
          case config.PITLOCK_ERROR_CODE_WORKING_END_TIME_OUT_OF_RANGE:
          case config.PITLOCK_ERROR_CODE_WORKING_TIME_INSPECTION_IMPOSSIBLE:
          case config.PITLOCK_ERROR_CODE_USER_CONFLICT:
          case config.PITLOCK_ERROR_CODE_CONNECTION:
            return true
        }
      }
      return false
    },
    /**
    * 予約内容入力画面、値プリセット関数
    * ※予約時にユーザー間バッティングエラーの場合、予約内容入力画面に遷移し
    * 値のプリセットが必要となる
    */
    inputPreset () {
      if (!this.preferredDateStore.preferredDate.post) return false
      this.pitlock.last_name = this.preferredDateStore.preferredDate.post.pitlock.last_name
      this.pitlock.first_name = this.preferredDateStore.preferredDate.post.pitlock.first_name
      this.inspection.tel = this.preferredDateStore.preferredDate.post.tel
      this.inspection.user_request = this.preferredDateStore.preferredDate.post.user_request
      this.inspection.replacement_vehicle_requested = this.preferredDateStore.preferredDate.post.replacement_vehicle_requested
    },
    estimatePage () {
      const carDataStore = useCarStore()
      carDataStore.car = this.preferredDateStore.preferredDate.car
      const nativeDataStore = useNativeDataStore()
      nativeDataStore.nativeData = this.preferredDateStore.preferredDate.nativeData
      const tsIdStore = useTsIdStore()
      tsIdStore.tsId = this.preferredDateStore.preferredDate.tsId
      const ssInfoStore = useSsInfoStore()
      ssInfoStore.ssInfo = this.preferredDateStore.preferredDate.ssInfo
      const inspectSsInfoStore = useInspectSsInfoStore()
      inspectSsInfoStore.inspectSsInfo = this.preferredDateStore.preferredDate.inspectSsInfo
      const profileInfoStore = useProfileInfoStore()
      profileInfoStore.profileInfo = this.preferredDateStore.preferredDate.profileInfo
      const versionDataStore = useVersionDataStore()
      versionDataStore.versionData = this.preferredDateStore.preferredDate.versionData

      this.$router.push({ name: 'EstimateV2' })
    }
  },
  async mounted () {
    console.log(location.href)
    // 車検実施SSをセット
    this.setSsInfo(this.preferredDateStore.preferredDate.inspectSsInfo)
    console.log('********* ssinfo')
    console.log(this.preferredDateStore.preferredDate.ssInfo)
    console.log('********* inspectSsInfo')
    console.log(this.preferredDateStore.preferredDate.inspectSsInfo)
    this.inputPreset()
    await this.getshopMenuList()
    if (this.pitlockCalendar.canUsePitlock) {
      await this.firstGetbookingCalendar(moment().format('YYYY-MM'), moment().add(1, 'months').format('YYYY-MM'))
    }
    this.loading = false
  }
}
</script>
